import React, { Component } from 'react';
import {
    NavLink, Navbar
} from 'reactstrap';
import '../styles/SiteSwitcher.css';
import AnnounceModal from '../components/AnnounceModal';
import { AUTH_TOKEN, CURR_NUMSCHI, IS_ADMIN, IS_LOGIN } from '../constants'
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

class SiteSwitcher extends Component {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) {
        super(props);
        this.loginCheck = this.loginCheck.bind(this);
        var whichLink = window.location.pathname
        if(whichLink ==="/raduno" || whichLink ==="/lodging" 
        || whichLink ==="/volunteer" || whichLink ==="/booking") {
            this.state = {
                home: "",
                raduno: "selectedLink",
            };
        } else {
            this.state = {
                home: "selectedLink",
                raduno: "ultra-pulse",
            };
        }
        
    }

    loginCheck() {
        console.log("SiteSwitcher in render and loginCheck");
        let sessionCookie = this.props.cookies.get('jsauth');
        if (localStorage.getItem(AUTH_TOKEN) !== null && sessionCookie === undefined) {
            console.log("SiteSwitcher session cookie is undefined, go to /login page");
            localStorage.setItem(IS_LOGIN, 'false');
            localStorage.removeItem(AUTH_TOKEN);
            localStorage.removeItem(CURR_NUMSCHI);
            localStorage.removeItem(IS_ADMIN);
            return false;
        }

        if (sessionCookie === undefined || sessionCookie === null) {
            return false;
        }
        var json = atob(sessionCookie);
        console.log("SiteSwitcher session json from server:")
        console.log(json);

        var value = JSON.parse(json);
        // console.log(value);

        var expiration = new Date(value.expiration);
        // console.log(expiration.toLocaleString());

        var now = new Date();
        // console.log(now.toLocaleString());

        if (expiration < now) {
            console.log("SiteSwitcher session cookie has expired, go to /login page");
            localStorage.clear();
            return false;
        }

        localStorage.setItem(AUTH_TOKEN, sessionCookie);
        localStorage.setItem(CURR_NUMSCHI, value.numschi);
        localStorage.setItem(IS_ADMIN, value.isAdmin);
        localStorage.setItem(IS_LOGIN, 'true');

        return true;
    }

    render() {

        return (
            <div className="SiteSwitcher">
                {(localStorage.getItem(IS_LOGIN) === 'false') && 
                    <AnnounceModal
                        forceShow={true}
                        title="Bentornato"
                        content="La tua sessione e' scaduta, per favore accedi di nuovo."
                        onClose={() => {
                            localStorage.removeItem('pop_status');
                            localStorage.removeItem(IS_LOGIN);
                        }}
                    />
                }
                {(this.loginCheck()) && (<Navbar bsstyle="tabs">
                    <NavLink href="/home" name="home"
                        className={this.state.home} title="Clicca qui per tornare alla pagina principale">
                        Clan Schiratti
                    </NavLink>
                    
                    <NavLink href="/raduno" name="raduno"
                        className={this.state.raduno} title="Clicca qui per tornare alla pagina del Raduno">
                            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                            <span style={{ marginRight: '4px', fontSize: '0.75em',fontStyle: 'italic', fontFamily: 'arial' }}>clicca qui  </span>
                        </div> Raduno 2025
                    </NavLink>
                </Navbar>)}               
            </div>
        );
    }
}
export default withCookies(SiteSwitcher);